import React from 'react';
import { Card, Spinner } from 'react-bootstrap';
import MetricHelpIcon from './MetricHelpIcon';

const DashboardStatCard = ({
  label,
  value,
  icon,
  color = 'primary',
  loading = false,
  helpText,
}) => (
  <Card className="dashboard-stat-card h-100">
    <Card.Body>
      <div className="d-flex align-items-center justify-content-between gap-2">
        <div className="status-card-content min-w-0">
          <p className="status-card-label text-muted mb-1 d-flex align-items-center gap-1">
            <span>{label}</span>
            <MetricHelpIcon text={helpText} id={`stat-${label}`} />
          </p>
          <h5 className="status-card-value mb-0 text-truncate">
            {loading ? <Spinner animation="border" size="sm" /> : value ?? 0}
          </h5>
        </div>
        {icon ? (
          <div className={`status-icon bg-${color}-subtle text-${color}`}>
            <i className={icon} />
          </div>
        ) : null}
      </div>
    </Card.Body>
  </Card>
);

export default DashboardStatCard;
